export const faqs = [
  {
    q: "瓜田黑料的内容是原创整理的吗？",
    a: "是的。站内所有盘点、榜单与合集都由编辑部根据公开信息重新梳理撰写，包括时间线整理、分类归纳与要点提炼，不是简单的搬运或聚合。",
  },
  {
    q: "你们的盘点会不会带有主观判断？",
    a: "我们尽量把事实与观点分开呈现。时间线、公开回应属于事实部分，会标注出处时间；分析和观察属于观点部分，会单独成段。遇到没有明确结论的话题，我们不会替任何一方下定论。",
  },
  {
    q: "为什么有的热门话题没有收录？",
    a: "收录标准有三条：信息有可靠来源、话题具有公开讨论价值、整理后对读者有补课意义。仅有传闻、缺乏公开信息支撑的内容，即使热度很高也不会单独成篇。",
  },
  {
    q: "名场面合集是怎么筛选的？",
    a: "主要参考回放量、二创数量与讨论持续时间三个指标，同时兼顾类别平衡，避免整期都是同一类型的片段。每个片段都会保留必要语境，防止断章取义。",
  },
  {
    q: "TOP 榜的排序依据是什么？",
    a: "综合讨论量、回放量与二创数量三个维度加权计算，其中二创数量权重最高，因为它更能反映话题的持续生命力。榜单只呈现关注度分布，不评价话题对错。",
  },
  {
    q: "发现内容有误或想提供后续进展，怎么联系你们？",
    a: "可以在「关于瓜田」页面通过线索征集表单提交，注明话题名称与信息来源。我们核实后会更新原文，并在页面上标注更正说明。",
  },
  {
    q: "网站会不会要求注册或付费？",
    a: "目前全部内容均可免费阅读，浏览盘点与合集不需要注册账号。后续如果上线收藏与订阅功能，会提前说明并保留免费浏览入口。",
  },
  {
    q: "内容多久更新一次？",
    a: "工作日保持每日更新，重大话题会在事件发生后 24 小时内补充时间线。年度盘点与年度 TOP 榜固定在每年 12 月下旬发布，并在次年持续做后续追踪。",
  },
];